/* src/app/modules/cooling-companion/components/system-status/system-status.component.scss */
.card-container {
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  overflow-x: auto;
}
.cooling-card {
  flex: 1 1 220px;
  height: 100px;
  display: flex;
  flex-direction: column;
  padding: 3px;
  box-sizing: border-box;
}
.cooling-card .label-subtext {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
}
.cooling-card .card-label {
  font-size: 15px;
  color: #040404;
  font-weight: 600;
}
.cooling-card .card-value {
  display: contents;
  font-size: 25px;
  font-weight: 600;
  color: #111;
  text-align: right;
  margin-left: 10px;
  min-width: 60px;
}
.cooling-card .card-subtext {
  font-size: 12px;
  color: #777;
}
.card-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  padding: 0 8px;
}
.image-loader {
  align-self: center;
  margin: auto;
}
.card-subtext {
  font-size: 12px;
  color: #777;
}
/*# sourceMappingURL=system-status.component.css.map */
